import Actions      from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"


export default ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_AVAILABLE_FEEDS] : (state,action)=>action.status,
  [Actions.RETRIEVE_AVAILABLE_FEEDS]   : ()=>false
})
